<script setup>
import { inject, onMounted, onBeforeUnmount } from "vue"
import { toast } from "vue3-toastify"
import "vue3-toastify/dist/index.css"

import ScrollToTop from "@core/components/ScrollToTop.vue"
import initCore from "@core/initCore"
import { initConfigStore, useConfigStore } from "@core/stores/config"
import { hexToRgb } from "@core/utils/colorConverter"
import { useTheme } from "vuetify"

const { global } = useTheme()

import DevToolsDetector from "@/aygulyazilim/components/DevToolsDetector.vue"
import { useWebPush } from "@/composables/useWebPush"

const { servisWorkerKayit } = useWebPush()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()
const socket = inject('socket')

import { useAnaSayfaStore } from "@/views/anasayfa/useAnaSayfa"
import { useAuthStore } from "@/aygulyazilim/store/useAuth"


const anaSayfaStore = useAnaSayfaStore()
const authStore = useAuthStore()

const getLocation = () => {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error('Geolocation is not available.'))
    }
    navigator.geolocation.getCurrentPosition(pos => { resolve(pos) }, err => { reject(err) })
  })
}

const locateMe = async () => {
  try {
    const location = await getLocation()
    let latitude = 0
    let longitude = 0
    let accuracy = 0
    if (location != null) {
      latitude = location.coords.latitude
      longitude = location.coords.longitude
      accuracy = location.coords.accuracy
      await anaSayfaStore.gonderKonum({ k: 1, latitude, longitude, accuracy })
    }
  } catch (e) {
    // console.log(e)
  }
}

const fetchDataTimer = async () => {
  setTimeout(() => {
    locateMe()
    fetchDataTimer()
  }, 300000)
}

const preventAction = e => {
  if (!authStore.user?.admin && !authStore.user?.programci) {
    e.preventDefault()
  }
}

onMounted(() => {
  locateMe()
  fetchDataTimer()

  servisWorkerKayit()

  window.addEventListener("contextmenu", preventAction)
  window.addEventListener("copy", preventAction)
  window.addEventListener("cut", preventAction)

  if (socket) {
    socket.on('test_event', data => {
      // console.log('Test event received:', data)
      toast.info(data.message || 'Socket mesajı alındı!', {
        autoClose: 3000,
      })
    })
    
    socket.on('connect', () => {
      // console.log('Socket Connected ID:', socket.id)
    })
  } else {
    // console.error('Socket not injected!')
  }
})

onBeforeUnmount(() => {
  window.removeEventListener("contextmenu", preventAction)
  window.removeEventListener("copy", preventAction)
  window.removeEventListener("cut", preventAction)
})
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <DevToolsDetector />
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp
      :style="`--v-global-theme-primary: ${hexToRgb(
        global.current.value.colors.primary
      )}`"
    >
      <RouterView />
      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
